@if (availability()) {
  <div class="cart-list-item-availability text-c2-m-300 color-black-warm-600">в наличии {{ availability() }}</div>
}
